export default {
      id: "ic-tv-circle-green-usage",
      viewBox: "0 0 15 15",
      url: "/" + "images/icons.3.109.2.svg#ic-tv-circle-green-usage",
      toString: function () {
        return this.url;
      }
    }